<template>
    <div class="section section-register-page registration-volonter">
        <div class="container" v-if="!state.success.show">
            <div class="row section-register-page__row">
                <div class="col d5 md-12">
                    <div class="registration-volonter__photo">
                        <div class="registration-volonter__photo-inner">
                            <div class="registration-volonter__photo-body">
                                <div class="registration-volonter__photo-media">
                                    <img :src="form.logo.preview ? form.logo.preview : '/local/templates/main/img/icons/icon-user.svg'">
                                </div>
                                <div class="registration-volonter__photo-text">{{ form.logo.hilt }}</div>
                            </div>
                            <a-input
                                :label="form.logo.title"
                                :name="form.logo.name"
                                :type="form.logo.type"
                                v-model="form.logo.value"
                                :error="form.logo.error"
                                @change="changePhoto($event)"
                            >
                            </a-input>
                        </div>
                    </div>
                </div>
                <div class="col d6 md-12">
                    <form :name="params.form.name" :action="params.form.action" :method="params.form.method" class="stepper-form" @submit.prevent="formSend($event)">
                      <h3>{{params.messages.title}}</h3>
                      <div class="form-group row">
                        <div :class="'d'+field.greedLang+' '+(field.type!=='hidden'?'col sm-12':'')" v-for="field in form.fields">
                          <input :type="field.type" :name="field.name" :value="field.value" v-if="field.type==='hidden'">
                          <a-input
                              v-if="field.type==='file'||field.type==='password'||field.type==='text'"
                              :type="field.type"
                              :class="field.class"
                              :label="field.title+(field.req?'*':'')"
                              :hint="field.hint"
                              :placeholder="field.placeholder?field.placeholder:field.title"
                              :name="field.name"
                              @keypress="field.error=false;"

                              :staticLabel="field.title!=''"
                              v-model="field.value"
                              :error="field.error"
                          >
                            <template #before v-if="field.leftIcon">
                              <div class="icon dark">
                                <img :src="field.leftIcon" width="25" height="25" style="filter: invert(1);object-fit: contain;">

                              </div>
                            </template>
                            <template #append v-if="field.type=='file'&&field.value">
                                <span class="a-field-file-clear" @click="field.value=''"></span>
                            </template>
                          </a-input>
                          <div class="textareaEditorWrap field static-label" :class="{ 'error': field.error }" v-if="field.type==='textarea'">
                            <label class="label">{{field.title}}*</label>
                            <div class="field-content">
                              <div class="control-wrap">
                                <ckeditor :editor="editor" v-model="field.value" :config="editorConfig"></ckeditor>
                              </div>
                            </div>
                          </div>
                          <a-date-picker
                              v-if="field.type==='date'"
                              :useManualInput="true"
                              :label="field.title+(field.req?'*':'')"
                              :placeholder="field.title"
                              :name="field.name"
                              staticLabel
                              v-model="field.value"
                              :error="field.error"
                              :class="{ 'error': field.error }"
                          />
                          <a-select
                              v-if="field.type==='select'"
                              :label="field.title+(field.req?'*':'')"
                              :placeholder="field.title"
                              :name="field.name"
                              @change="field.error=false;"
                              staticLabel
                              v-model="field.value"
                              :error="field.error"
                              :options="field.options"
                              value="id"
                              display="name"
                              :class="{ 'error': field.error }"
                          />
                          <div class="diapazon" v-if="field.type==='diapazon'">
                            <div class="field static-label filled">
                              <div class="field-content">
                                <div class="control-wrap" tabindex="-1">
                                  <label class="label">{{field.title+(field.req?'*':'')}}</label>
                                  <div class="row">
                                    <div class="d6 col sm-12" :class="'d'+(field.fields.length/2)" v-for="subField in field.fields">
                                      <a-input
                                          label=""
                                          :placeholder="subField.title"
                                          :name="subField.name"
                                          :type="subField.type"
                                          @keypress="subField.error=false;"
                                          v-model="subField.value"
                                          :error="subField.error"
                                      />
                                    </div>

                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="form__section" v-if="field.type==='checkboxes'">
                            <div class="row">
                              <div class="col d6 sm-12" v-for="subField in field.fields">
                                <div class="form-group">
                                  <a-checkbox
                                      :label="subField.title"
                                      :name="subField.name"
                                      v-model="subField.selected"
                                      :value="subField.value"
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="form__section" v-if="field.type==='subtitle'">
                            <h3 >{{field.title}}</h3>
                          </div>
                          <div class="form-group  fields-group" v-if="field.type=='moreSotsLink'">
                            <ABtn class="form-btn btn-add" fill="transparent" type="button" @click="addSocialLink(field)">
                              <template #before>
                                <svg class="icon" width="20" height="20" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                                  <rect y="9" width="20" height="2"/>
                                  <rect x="9" y="20" width="20" height="2" transform="rotate(-90 9 20)"/>
                                </svg>
                              </template>
                              <template #content>{{field.messages.btnAdd}}</template>
                            </ABtn>
                            <div class="row nowrap" v-for="(social, i) in field.links" :key="i">
                              <div class="col d5 sm-6" :class="'d'+linkField.greedLang" v-for="(linkField,k) in social">
                                <a-input
                                    v-if="linkField.type=='text'||linkField.type=='textarea'"
                                    :label="linkField.title"
                                    staticLabel
                                    v-model="linkField.value"
                                    :error="linkField.error"
                                >
                                  <template #before v-if="k==0">
                                    <ABtn type="button" class="social-link__remove" fill="flat" style="color: #68737D;" @click="removeSocialLink(i,field.links)">
                                      <template #content>
                                        <svg width="20" height="20" viewBox="0 0 20 2" fill="none" xmlns="http://www.w3.org/2000/svg">
                                          <rect width="20" height="2" fill="#68737D"/>
                                        </svg>
                                      </template>
                                    </ABtn>
                                  </template>
                                </a-input>
                              </div>
                            </div>
                          </div>
                          <div v-if="field.type=='languableBlock'">
                            <a-checkbox
                                :label="field.title"
                                v-model="field.selected"
                            />
                            <div class="form__section" v-if="field.selected">
                              <template v-for="ln in field.langs">
                                <div class="form__section"><h3>{{ ln.blockTitle }} <span class="text-400 capitalize">{{ ln.title }}</span></h3></div>
                                <div class="form-group row">
                                  <div class="col sm-12" :class="'d'+fieldLang.greedLang" v-for="fieldLang in field.values[ln.title]">
                                   <a-input
                                       v-if="fieldLang.type!='textarea'"
                                       :type="fieldLang.type"
                                       :class="fieldLang.class"
                                       :label="fieldLang.title+(fieldLang.req?'*':'')"
                                       :hint="fieldLang.hint"
                                       :placeholder="fieldLang.placeholder?fieldLang.placeholder:fieldLang.title"
                                       :name="fieldLang.name"
                                       @keypress="fieldLang.error=false;"
                                       :staticLabel="fieldLang.title!==''"
                                       v-model="fieldLang.value"
                                       :error="fieldLang.error"
                                   />
                                      <div class="textareaEditorWrap" v-if="fieldLang.type=='textarea'">
                                          <label class="label">{{fieldLang.title}}</label>
                                          <ckeditor :editor="editor" v-model="fieldLang.value" :config="editorConfig"></ckeditor>
                                      </div>
                                  </div>
                                </div>
                              </template>
                            </div>

                          </div>
                        </div>
                        <div class="form__actions col sm-12 d12">
                          <ABtn class="dark d12" :label="params.messages.confirmBtn"/>
                        </div>
                        <div class="form__actions col sm-12 d12">
                          <ABtn class="outlined dark d12" @click.prevent="saveDraft" :label="params.messages.saveDraftBtn"/>
                        </div>
                      </div>
                    </form>
                </div>
            </div>
        </div>

        <div class="register-success" v-if="state.success.show">
            <div class="register-success__body">
                <div class="register-success__icon">
                    <img src="/local/templates/main/img/icons/ok-hand.png" alt="">
                </div>
                <div class="register-success__title h2">{{ state.success.title }}</div>
                <div class="register-success__desc" v-html="state.success.desc"></div>
                <ABtn :label="params.messages.OkBtn" :href="state.success.url" class="primary" />
            </div>
        </div>

    </div>
</template>

<script>
import { AField, AInput, ACheckbox, ABtn, ASelect, AChip, ADatePicker, useAProgressBar } from '../ui'
import {send, sendRegisterNPO} from '../../services/api'
import { getType } from '../ui/utils/helpers'
import { nextTick, ref, computed, watch } from 'vue'
import { required, isEmail, isPhone, fileRules } from '../../libs/Validators'
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
export default {
    name: 'RegistrationVolonter',
    components: {
        AChip,
        AField,
        AInput,
        ACheckbox,
        ABtn,
        ASelect,
        ADatePicker,
    },
    props: ['params'],
    data() {
        return {
            editor: ClassicEditor,
            editorConfig: {
                toolbar: [
                    'heading',
                    '|',
                    'bold',
                    'italic',
                    'link',
                    'bulletedList',
                    'numberedList',
                    'blockQuote',
                    'insertTable'
                ],
                heading: {
                    options: [
                        { model: 'paragraph', title: 'Paragraph', class: 'ck-heading_paragraph' },
                        { model: 'heading2', view: 'h2', title: 'Heading 2', class: 'ck-heading_heading2' },
                        { model: 'heading3', view: 'h3', title: 'Heading 3', class: 'ck-heading_heading3' }
                    ]
                }
                // The configuration of the editor.
            }
        };
    },
    setup: (props, ctx) => {

        const progress = useAProgressBar();
        const state = ref({
            success: props.params.success,
        });
        const changePhoto = (e) => {
        const file = e.target.files[0];
        form.value.logo.preview = URL.createObjectURL(file)
      };
        const addSocialLink = (field) => {
        const copyObject = JSON.parse(JSON.stringify(field.fields));
        field.links.push(copyObject);
      }
        const removeSocialLink = (i,field) => {
          field.splice(i, 1);
        }
        const form = ref({
          processed: false,
          additional_langs: false,
          logo:props.params.form.logo,
          fields: props.params.form.fields,
        });
        if(props.params.form.draft) {
          for(let index in form.value.fields) {
            if(form.value.fields[index]?.name?.includes('REGISTER[')) {
              let name = form.value.fields[index].name.replace('REGISTER[','');
              name = name.replace(']','');
              if(props.params.form.draft[name]) {
                if(
                    form.value.fields[index].type=="text"||
                    form.value.fields[index].type=="textarea"||
                    form.value.fields[index].type=="date"
                ) {
                  form.value.fields[index].value = props.params.form.draft[name];
                } else if(form.value.fields[index].type=="select") {
                  form.value.fields[index].value = props.params.form.draft[name];
                } else {
                  console.log(form.value.fields[index]);
                  console.log(props.params.form.draft[name]);
                }

              }

            }

          }


        }




        const languable = [];
        for (let index in form.value.fields) {
          if(form.value.fields[index].languable) {
            const copyObject = JSON.parse(JSON.stringify(props.params.form.fields[index]));
            copyObject.value="";
            languable.push(copyObject);
          }
        }
        let langBlock = false;
        for (let index in form.value.fields) {
          if(form.value.fields[index].type==="languableBlock") {
            langBlock = index;
          }
        }
        for (let index in props.params.form.langs) {
          if(props.params.form.langs[index].title!==undefined) {
            for (let languageIndex in languable) {
              if(languable[languageIndex].title!==undefined) {
                const copyObject = JSON.parse(JSON.stringify(languable[languageIndex]));
                copyObject.name = copyObject.languableName.replace('#LANG#', props.params.form.langs[index].title.toUpperCase());
                copyObject.title = copyObject.languableTitle[props.params.form.langs[index].title];
                form.value.fields[langBlock].values[props.params.form.langs[index].title].push(copyObject);
              }
            }
          }
        }
        const CheckOneField = (field,draft) => {
          if(draft===undefined||!draft) {
            draft = false;
          }
          if(field.error) {
            field.error = false;
          }
          if(field.req&&!draft) {
            if(field.reqtype==="file") {
              if (!field.value) {
                return false;
              }
            } else if (field.value?.trim()===""||!field.value) {
              return false;
            }
          }
          if(field.reqtype) {
            switch (field.reqtype) {
              case "email":
                if (!isEmail(field.value)) {
                  return false;
                }
              break;
              case "phone":
                if(!isPhone(field.value)) {
                  return false;
                }
              break;
              case "password":
                if(field.compare) {
                  let norm = false;
                  const fields = form.value.fields;
                  for(let f in fields) {
                    if(fields[f].name===field.compare) {
                      if(field.value===fields[f].value) {
                        norm = true;
                      }
                    }
                  }
                  if(!norm) {
                    return false;
                  }
                }
                break;
              case "file":
                if(field.formats||field.maxSize) {
                  if(!fileRules(field.value, { maxSize: field.maxSize, allowedExt: field.formats})) {
                    return false;
                  }
                }
              break;
            }
          }
          return true;
        }
        const validate = (draft) => {
          const fields = form.value.fields;
          let good = true;
          let firsErrorField = false;
          for(let index in fields) {
            if(fields[index].type !==undefined) {
              if(Array.isArray(fields[index].links)) {
                for(let linkIndex in fields[index].links) {
                  for(let fieldIndex in fields[index].links[linkIndex]) {
                    if(!CheckOneField(fields[index].links[linkIndex][fieldIndex],draft)) {
                      fields[index].links[linkIndex][fieldIndex].error = true;
                      if(!firsErrorField) {
                        firsErrorField = fields[index].links[linkIndex][fieldIndex];
                      }
                      good = false;
                    }
                  }
                }
              } else if(!CheckOneField(fields[index],draft)) {
                if(!firsErrorField) {
                  firsErrorField = fields[index];
                }
                fields[index].error = true;
                good = false;
              }
            }
          }
          if(form.value.logo.value) {
            if(!CheckOneField(form.value.logo,draft)) {
              form.value.logo.error = true;
              if(!firsErrorField) {
                firsErrorField = form.value.logo;
              }
              good = false;
            }
          }

          if(firsErrorField) {
            nextTick(() => {
              document.querySelector('.field.error').scrollIntoView({block:"center",behavior: 'smooth'});
            });
          }
          return good;
        }
        const makeFormData = () => {
          const formData = new FormData();
          for(let index in form.value.fields) {
            if(form.value.fields[index].type !==undefined) {
              if(getType(form.value.fields[index].value) === 'FileList') {
                formData.append(form.value.fields[index].name,form.value.fields[index].value[0]);
              }
              else if(form.value.fields[index].type==="moreSotsLink") {
                if(Array.isArray(form.value.fields[index].links)&&form.value.fields[index].links.length>0) {
                  for(let linkIndex in form.value.fields[index].links) {
                    for(let subIndex in form.value.fields[index].links[linkIndex]) {
                      formData.append(form.value.fields[index].links[linkIndex][subIndex].name,form.value.fields[index].links[linkIndex][subIndex].value);
                    }
                  }
                }
              }
              else if(form.value.fields[index].type==="languableBlock") {
                for(let ln in form.value.fields[index].values) {
                  for(let subIndex in form.value.fields[index].values[ln]) {

                    formData.append(form.value.fields[index].values[ln][subIndex].name,form.value.fields[index].values[ln][subIndex].value);
                  }
                }
              }
              else if(Array.isArray(form.value.fields[index].fields)) {
                for(let subIndex in form.value.fields[index].fields) {
                  if(form.value.fields[index].type==="checkboxes") {
                    if(form.value.fields[index].fields[subIndex].selected!==undefined) {
                      formData.append(form.value.fields[index].fields[subIndex].name,form.value.fields[index].fields[subIndex].value);
                    }
                  }
                  else {
                    formData.append(form.value.fields[index].fields[subIndex].name,form.value.fields[index].fields[subIndex].value);
                  }
                }
              }
              else if(form.value.fields[index].value!==undefined&&form.value.fields[index].value) {
                formData.append(form.value.fields[index].name,form.value.fields[index].value);
              }
            }
          }
          if(form.value.logo.value) {
            formData.append(form.value.logo.name,form.value.logo.value[0]);
          }
          return formData;
        }
        const saveDraft = async () => {
          if(!validate(1)) return;
          progress.show();
          const formData = makeFormData();
          for (let key in props.params.form.saveDraft.data) {
            formData.append(key, props.params.form.saveDraft.data[key]);
          }
          await send(props.params.form.saveDraft.link, {method:"POST"},formData).then((response) => {

            if(response.error!=undefined) {
              //Все плохо
              showNotification('danger','',response.error);
            } else if(response.success!=undefined) {
              //Все хорошо
              showNotification(
                  'nativeSuccess',
                  response.title,
                  response.success,
                  {
                    actions:[
                      {
                        bg:'#00A59E',
                        color:'',
                        title:response.okBtn,
                        action:false,
                        paternAction:'close'
                      }
                    ]
                  });
            } else {
              //Все не понятно
              console.log(response);
              alert('Все не понятно');
            }






            progress.hide();
          });
        }
        const formSend = async (e) => {
          if(!validate()) return;
          progress.show();
          const formData = makeFormData();


          await send(props.params.form.action, {method:props.params.form.method},formData).then((response) => {
            if(response["RegistrationVolonter"]['information']) {
              let notyByType = {};
              for (let index in response["RegistrationVolonter"]['information'])  {
                if(response["RegistrationVolonter"]['information'][index].type!==undefined) {
                  if(notyByType[response["RegistrationVolonter"]['information'][index].type]===undefined) {
                    notyByType[response["RegistrationVolonter"]['information'][index].type] = [];
                  }
                  notyByType[response["RegistrationVolonter"]['information'][index].type].push(response["RegistrationVolonter"]['information'][index].text);
                }
              }
              for (let type in notyByType) {
                showNotification(type,'',notyByType[type].join('<br>'));
              }
            }
            if(response["RegistrationVolonter"]['success']['show']) {
              state.value.success = response["RegistrationVolonter"]['success'];
            }
            progress.hide();
          });
        }
        return {
          form,
          state,
          required,
          saveDraft,
          isEmail,
          isPhone,
          fileRules,
          changePhoto,
          addSocialLink,
          removeSocialLink,
          formSend,
        }
    },
}
</script>

<style lang="scss">
  .diapazon>.field>.field-content {
    background: none;
    .field.filled {
      margin-top: 0;
      .label {
        display: none;
      }
    }

  }
  .diapazon>.field>.field-content:before {
    display: none;
  }
    .registration-volonter {
        .section-register-page {
            &__row > .col.d5 {
                @include tablet {
                    display: flex;
                    justify-content: flex-end;
                }
            }
        }
        &__photo {
            margin-top: 80px;
            max-width: 327px;
            border-radius: var(--br-1);
            overflow: hidden;
            box-shadow: 0px 1px 1px rgba(0, 0, 0, 0.05), 0px 0px 40px rgba(0, 0, 0, 0.1);
            background: var(--c-gray-700);
            position: sticky;
            top: 120px;

            @include tablet {
                max-width: 240px;
                margin-top: -228px;
                position: relative;
                top: auto;
            }

            @include mobile {
                max-width: initial;
                width: 100%;
                margin-top: -100px;
            }

            &-inner {
                text-align: center;
            }
            &-body {
                padding: 54px 25px 25px 25px;
                @include tablet {
                    padding: 28px 12px 12px 12px;
                }
            }
            &-media {
                margin: 0 auto 60px auto;
                width: 150px;
                height: 150px;
                border-radius: 50%;
                overflow: hidden;

                @include tablet {
                    width: 100px;
                    height: 100px;
                    margin-bottom: 28px;
                }

                img {
                    object-fit: cover;
                    width: 100%;
                    height: 100%;
                }
            }
            &-text {
                font-size: 12px;
                line-height: 18px;
                color: var(--c-gray-400);
                max-width: 230px;
                margin: 0 auto;
            }

            .field {
                margin: 0;
                min-height: initial;
                &-content {
                    background: #fff !important;
                    border: none;
                    border-radius: 0;
                    min-height: initial;
                    &::before {
                        background: #fff !important;
                        border: none !important;
                    }
                }
                .control-wrap {
                    min-height: initial;
                }
                .label {
                    position: relative;
                    left: auto;
                    top: auto;
                    margin: 0;
                    transform: none;
                    display: inline-flex;
                    align-items: center;
                    justify-content: center;
                    text-align: center;
                    height: 70px;
                    cursor: pointer;
                    font-weight: 600;
                    font-size: 14px;
                    color: var(--c-primary-200);

                    @include tablet {
                        height: 52px;
                    }
                }
                .input,
                .a-field-file-input {
                    display: none;
                }
            }
        }
    }

  .textareaEditorWrap.field.static-label.error {
    padding: 15px;
    border: 1px solid #dc2424;
    border-radius: 14px;
  }

</style>